/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CancelSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  id: string;
  /**
   * Subscription cancellation options
   */
  cancelSubscriptionRequestEntity: components.CancelSubscriptionRequestEntity;
};

/** @internal */
export const CancelSubscriptionRequest$inboundSchema: z.ZodType<
  CancelSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  CancelSubscriptionRequestEntity:
    components.CancelSubscriptionRequestEntity$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "CancelSubscriptionRequestEntity": "cancelSubscriptionRequestEntity",
  });
});
/** @internal */
export type CancelSubscriptionRequest$Outbound = {
  id: string;
  CancelSubscriptionRequestEntity:
    components.CancelSubscriptionRequestEntity$Outbound;
};

/** @internal */
export const CancelSubscriptionRequest$outboundSchema: z.ZodType<
  CancelSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  CancelSubscriptionRequest
> = z.object({
  id: z.string(),
  cancelSubscriptionRequestEntity:
    components.CancelSubscriptionRequestEntity$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    cancelSubscriptionRequestEntity: "CancelSubscriptionRequestEntity",
  });
});

export function cancelSubscriptionRequestToJSON(
  cancelSubscriptionRequest: CancelSubscriptionRequest,
): string {
  return JSON.stringify(
    CancelSubscriptionRequest$outboundSchema.parse(cancelSubscriptionRequest),
  );
}
export function cancelSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<CancelSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CancelSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CancelSubscriptionRequest' from JSON`,
  );
}
